import { Component, inject, OnInit } from '@angular/core';
import { NgbCalendar, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { EgInputComponent } from './shared/components/eg-input/eg-input.component';
import { EgButtonComponent } from './shared/components/eg-button/eg-button.component';
import { RouterModule, RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { filter } from 'rxjs/operators';
import { EgHeaderComponent } from './shared/components/eg-header/eg-header.component';
import { EgNavBarComponent } from './shared/components/eg-nav-bar/eg-nav-bar.component';
import { NotificationsComponent } from './modules/notifications/notifications.component';
import { FcmService } from './shared/services/fcm.service';
import { ToastrService } from 'ngx-toastr';
import { resetFaviconToDefault } from './shared/services/favicon-util';
import { SharedCaseManagementService } from './shared/services/shared-case-management.service';
import { PortalService } from './shared/services/portal.service';


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    CommonModule,
    HttpClientModule,
    EgHeaderComponent,
    EgNavBarComponent,
    EgInputComponent,
    EgButtonComponent,
    RouterModule,
    NotificationsComponent
  ],
  host: { class: 'd-block' },
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    }
  ]
})
export class AppComponent implements OnInit {
  model!: NgbDateStruct;
	date!: { year: number; month: number; };
  today = inject(NgbCalendar).getToday();
  isLoginPage = false;
  isApplicantDetailPage = false;
  isAccountSetupSuccessPage = false;
  isAccountSetupPage = false;
  isRiderLoginPage = false;
  isRiderDashboardPage = false;
  isRiderUserProfilePage = false;
  isRiderApplicationPage = false;
  isRiderSettingsPage = false;
  constructor(
    private readonly router: Router,
    private readonly fcmService: FcmService,
    private readonly toastr: ToastrService,
    private readonly sharedCaseManagementService: SharedCaseManagementService,
    private readonly portalService: PortalService
  ) {}

  ngOnInit() {
    this.sharedCaseManagementService.fcmToken$.subscribe((token: any) => {
      if (token) {
        let userId = sessionStorage.getItem('userId');
        let agencyId = sessionStorage.getItem('agencyId');
        if (userId && agencyId) {
          this.fcmService.sendTokenToBackend(userId, agencyId, token).subscribe((response: any) => {
            if(response) {
              this.fcmService.listenToMessages();
              this.fcmService.listenToBroadcastChannel();
            }
          },
          (error: any) => {
            console.error('Error sending FCM token to server:', error);
          });
        }
        else {
          console.error('User ID or Agency ID is not available in session storage');
          return;
        }
      } 
      /* else {
        console.error('Failed to retrieve FCM token');
      } */
    });
    // Set flags immediately on init for the current URL (before any NavigationEnd fires)
    this.updateRouteFlags(this.router.url);

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      // Use urlAfterRedirects so /rider → /rider/login redirect is reflected correctly
      this.updateRouteFlags(event.urlAfterRedirects ?? this.router.url);
    });

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        resetFaviconToDefault('assets/images/favicon.png'); //  reset favicon
      }
    });
  }

  private updateRouteFlags(url: string): void {
    this.isLoginPage               = url === '/';
    this.isApplicantDetailPage     = url.startsWith('/applicant-detail');
    this.isAccountSetupSuccessPage = url.startsWith('/account-setup-success');
    this.isAccountSetupPage        = url.startsWith('/account-setup');
    // Match both /rider/... and /:agencySlug/rider/... patterns
    this.isRiderLoginPage          = url.startsWith('/rider/login')        || /^\/[^/]+\/rider\/login/.test(url);
    this.isRiderDashboardPage      = url.startsWith('/rider/dashboard')    || /^\/[^/]+\/rider\/dashboard/.test(url);
    this.isRiderUserProfilePage    = url.startsWith('/rider/profile')      || /^\/[^/]+\/rider\/profile/.test(url);
    this.isRiderApplicationPage    = url.startsWith('/rider/application')  || /^\/[^/]+\/rider\/application/.test(url);
    this.isRiderSettingsPage       = url.startsWith('/rider/settings')     || /^\/[^/]+\/rider\/settings/.test(url);
  }
}
